// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__220WA","title":"FrontImage_title__3pUqC"};